import React from 'react'

import EditRoleForm from '../../modules/Role/components/EditRoleForm'
export default function EditRolePage() {
  return <EditRoleForm />
}
